export default "/images/vendor/flag-icon-css/flags/4x3/gp.svg?197c13c37e6fb1e34e2f99424a9dadbf";